export const environment = {
  production: false,
  environmentName: 'dev',
  deployBucketName: 'dia-cint-deploy-frontend-dev',
  redirectUri: 'https://atcint.diaview.aws.postnord.com',
  msalConfig: {
    auth: {
      clientId: '609dbd43-cc34-48af-b05d-57168e0e1a92',
      authority: 'https://login.microsoftonline.com/91f09566-a850-4fae-bbe1-29ad3804a2f6'
    }
  },
  apiConfig: {
    scopes: ['openid', 'profile'],
    uri: 'https://graph.microsoft.com/v1.0/me',
    apirooturi: "https://atcint.diaview.aws.postnord.com",
  },


};
